module.exports = __webpack_public_path__ + "static/img/04.6ce97e9f.png";